import { useEffect, useRef } from 'react';
import type { AllyMessage } from '@lib/hooks/useAlly';

export interface AllyMessageListProps {
  messages: ReadonlyArray<AllyMessage>;
  busy: boolean;
}

export function AllyMessageList({ messages, busy }: AllyMessageListProps) {
  const logRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (logRef.current) logRef.current.scrollTop = logRef.current.scrollHeight;
  }, [messages, busy]);

  return (
    <div className="ally__log" ref={logRef} aria-live="polite">
      {messages.map((m, i) => (
        <div key={i} className={`msg ${m.role === 'user' ? 'me' : 'bot'}`}>
          {m.text}
        </div>
      ))}
      {busy && (
        <div className="msg bot typing" aria-label="Ally is typing">
          <span /><span /><span />
        </div>
      )}
    </div>
  );
}
